import axios from 'axios';
import router from '../router'
import qs from 'qs';
import vant from 'vant';
import { Toast } from 'vant';
import JSONBIG from 'json-bigint';
import VConsole from 'vconsole'
import plugins from '../plugins'
import regular from '../utils/regular'
export default {
  install: Vue => {
    Vue.use(vant)
    Vue.use(plugins)
    // if (process.env.VUE_APP_IS_LOG == 1) {
    //   const vConsole = new VConsole()
    //   Vue.use(vConsole)
    // }
    Vue.prototype.$rg = regular //部分正则
    Vue.prototype.$axios = axios
    // axios.defaults.withCredentials = true
    // js返回进度丢失
    axios.defaults.transformResponse = [
      function (data) {
        const json = JSONBIG({ storeAsString: true })
        const res = json.parse(data)
        return res
      }
    ]
    axios.defaults.timeout = 30000000; //请求超时
    const no_login_code = -1;       //未登录 状态码
    const success_code = 1;         //成功 状态码
    const err_code = 0;             //失败 状态码
    const token_headers = true      // true->token headers 传值

    console.warn(`%c ${process.env.NODE_ENV}`, 'background:#328ee6;padding:0 5px 1px 0;border-radius: 3px 0 0 3px;  color: #ffffff')
    if (process.env.NODE_ENV == 'development') setpath('http://www.dabcontract.com/')
    else if (process.env.NODE_ENV == 'production') setpath('http://www.dabcontract.com/')
    function setpath(api_path = '', web_path = api_path, ws_path = '') {
      axios.defaults.baseURL = api_path;
      Vue.prototype.httpPath = web_path;
      Vue.prototype.wsPath = ws_path;
      console.log(`%c token headers ：${token_headers}`, 'background:#328ee6;padding:0 5px 1px 0;border-radius: 3px 0 0 3px;  color: #ffffff')
      api_path && console.log(`%c api_path ${api_path}`, 'background:#328ee6;padding:0 5px 1px 0;border-radius: 3px 0 0 3px;  color: #ffffff')

      web_path && console.log(`%c web_path ${web_path}`, 'background:#328ee6;padding:0 5px 1px 0;border-radius: 3px 0 0 3px;  color: #ffffff')

      ws_path && console.log(`%c ws_path ${ws_path}`, 'background:#328ee6;padding:0 5px 1px 0;border-radius: 3px 0 0 3px;  color: #ffffff')
    }

    let lang = { zh: 'zh_CN', en: 'en', }
    Vue.prototype.$get = params => {
      const token = Vue.prototype.local.get("token") || "";
      let data
      params.loading && Toast.loading({
        forbidClick: true,
        duration: 0
      });
      if (token_headers) {
        data = {
          params: Object.assign({}, params.data),
          headers: {
            'authorization': `Bearer ${token}`,
            'locale': lang[Vue.prototype.local.get("lang") || 'zh']
          }
        }
      } else {
        data = {
          params: Object.assign({}, params.data, token ? { token } : '')
        }
      }
      axios.get(params.url, data).then(res => {
        params.loading && Toast.clear();
        if (res.data.code == no_login_code) {
          if (token) Vue.prototype.local.del("token");
          // Toast({
          //   message: '未登录',
          //   onClose: () => {
          //     router.replace('/')
          //   }
          // });
        } else if (res.data.code == success_code) {
          params.success && params.success(res.data);
        } else if (res.data.code == err_code) {
          if (params.tip) {
            params.tip(res.data)
            Toast(res.data.msg || res.data.message);
          } else if (params.tips) {
            params.tips(res.data)
          }
        }
      }).catch(err => {
        console.log('请求失败', err.response)
        err.response && Toast(`${err.response.config.url} ${err.response.status}`);
      })
    }
    Vue.prototype.$del = params => {
      const token = Vue.prototype.local.get("token") || "";
      let data
      params.loading && Toast.loading({
        forbidClick: true,
        duration: 0
      });
      if (token_headers) {
        data = {
          params: Object.assign({}, params.data),
          headers: {
            'authorization': `Bearer ${token}`
          }
        }
      } else {
        data = {
          params: Object.assign({}, params.data, token ? { token } : '')
        }
      }
      axios.delete(params.url, data).then(res => {
        params.loading && Toast.clear();
        if (res.data.code == no_login_code) {
          if (token) Vue.prototype.local.del("token");
          // Toast({
          //   message: '未登录',
          //   onClose: () => {
          //     router.replace('/')
          //   }
          // });
        } else if (res.data.code == success_code) {
          params.success && params.success(res.data);
        } else if (res.data.code == err_code) {
          if (params.tip) {
            params.tip(res.data)
            Toast(res.data.msg || res.data.message);
          } else if (params.tips) {
            params.tips(res.data)
          }
        }
      }).catch(err => {
        console.log('请求失败', err.response)
        err.response && Toast(`${err.response.config.url} ${err.response.status}`);
      })
    }

    Vue.prototype.$post = params => {
      const token = Vue.prototype.local.get("token") || "";
      let data = {}
      let headers = {
        'locale': lang[Vue.prototype.local.get("lang") || 'zh']
      }
      params.loading && Toast.loading({
        forbidClick: true,
        duration: 0
      });
      if (token_headers) {
        headers = {
          'authorization': `Bearer  ${token}`,
          'locale': lang[Vue.prototype.local.get("lang") || 'zh']
        }
        if (params.upload) {
          headers['Content-Type'] = 'multipart/form-data';
          data = params.data
        } else if (params.noToken) {
          headers = {}
          data = params.data  //有时候java传值方式
          // data = qs.stringify(Object.assign({}, params.data))
        } else if (params.raw) {
          headers['Content-Type'] = 'multipart/form-data';
          data = params.data
        } else {
          // data = params.data //有时候java传值方式
          data = qs.stringify(Object.assign({}, params.data))
        }
      } else {
        if (params.upload) {
          data = params.data.append('token', token ? token : "")
          headers['Content-Type'] = 'multipart/form-data'
        } else if (params.noToken) {
          data = qs.stringify(Object.assign({}, params.data))
        } else {
          data = qs.stringify(Object.assign({}, params.data, token ? { token } : {}))
        }
      }
      axios.post(params.url, data, { headers }).then(res => {
        params.loading && Toast.clear();
        if (res.data.code == no_login_code) {
          if (token) Vue.prototype.local.del("token");
          // Toast({
          //   message: '未登录',
          //   onClose: () => {
          //     router.replace('/')
          //   }
          // });
        } else if (res.data.code == success_code) {
          params.success && params.success(res.data);
        } else if (res.data.code == err_code) {
          if (params.tip) {
            params.tip(res.data)
            Toast(res.data.msg || res.data.message);
          } else if (params.tips) {
            params.tips(res.data)
          }
        }
      }).catch(err => {
        console.log('请求失败', err.response)
        err.response && Toast(`${err.response.config.url} ${err.response.status}`);
      })
    }

    Vue.prototype.$put = params => {
      const token = Vue.prototype.local.get("token") || "";
      let data = {}
      let headers = {}
      params.loading && Toast.loading({
        forbidClick: true,
        duration: 0
      });
      if (token_headers) {
        headers['authorization'] = `Bearer ${token}`
        if (params.upload) {
          headers['Content-Type'] = 'multipart/form-data';
          data = params.data
        } else if (params.noToken) {
          headers = {}
          data = params.data  //有时候java传值方式
          // data = qs.stringify(Object.assign({}, params.data))
        } else if (params.raw) {
          headers['Content-Type'] = 'multipart/form-data';
          data = params.data
        } else {
          // data = params.data //有时候java传值方式
          data = qs.stringify(Object.assign({}, params.data))
        }
      } else {
        if (params.upload) {
          data = params.data.append('token', token ? token : "")
          headers['Content-Type'] = 'multipart/form-data'
        } else if (params.noToken) {
          data = qs.stringify(Object.assign({}, params.data))
        } else {
          data = qs.stringify(Object.assign({}, params.data, token ? { token } : {}))
        }
      }
      axios.put(params.url, data, { headers }).then(res => {
        params.loading && Toast.clear();
        if (res.data.code == no_login_code) {
          if (token) Vue.prototype.local.del("token");
          // Toast({
          //   message: '未登录',
          //   onClose: () => {
          //     router.replace('/')
          //   }
          // });
        } else if (res.data.code == success_code) {
          params.success && params.success(res.data);
        } else if (res.data.code == err_code) {
          if (params.tip) {
            params.tip(res.data)
            Toast(res.data.msg || res.data.message);
          } else if (params.tips) {
            params.tips(res.data)
          }
        }
      }).catch(err => {
        console.log('请求失败', err.response)
        err.response && Toast(`${err.response.config.url} ${err.response.status}`);
      })
    }

    Vue.prototype.$post_pr = params => {
      const token = Vue.prototype.local.get("token") || "";
      let data = {};
      let headers = {
        'locale': lang[Vue.prototype.local.get("lang") || 'zh']
      };

      // 显示 loading（如果需要）
      if (params.loading) {
        Toast.loading({ forbidClick: true, duration: 0 });
      }

      // 构建 headers 和 data（略，保持你原有逻辑）
      if (token_headers) {
        headers['authorization'] = `Bearer ${token}`;
        if (params.upload || params.raw) {
          headers['Content-Type'] = 'multipart/form-data';
          data = params.data;
        } else if (params.noToken) {
          headers = {};
          data = params.data;
        } else {
          data = qs.stringify(Object.assign({}, params.data));
        }
      } else {
        // ...（略，保持你原有逻辑）
      }

      // 返回 Promise！
      return axios.post(params.url, data, { headers })
        .then(res => {
          if (params.loading) Toast.clear();

          const { code, msg, message } = res.data;

          if (code === no_login_code) {
            if (token) Vue.prototype.local.del("token");
            // 可选：跳转登录
            // router.replace('/');
            // 抛出错误，便于 await 捕获
            return Promise.reject(new Error('未登录'));
          } else if (code === success_code) {
            // 兼容旧回调
            params.success && params.success(res.data);
            // ✅ 关键：resolve 成功数据
            return Promise.resolve(res.data);
          } else if (code === err_code) {
            const errorMsg = msg || message || '请求失败';
            if (params.tip) {
              params.tip(res.data);
              Toast(errorMsg);
            } else if (params.tips) {
              params.tips(res.data);
            }
            // ✅ 抛出错误，便于 await 捕获
            return Promise.reject(new Error(errorMsg));
          }
        })
        .catch(err => {
          if (params.loading) Toast.clear();
          console.error('请求失败', err.response || err);

          if (err.response) {
            Toast(`${err.response.config.url} ${err.response.status}`);
          }

          // ✅ 向上抛出错误
          return Promise.reject(err);
        });
    };
  }
}